import { render } from "./AdviserRoomAssign.vue?vue&type=template&id=4f6b2d2a"
import script from "./AdviserRoomAssign.vue?vue&type=script&lang=js"
export * from "./AdviserRoomAssign.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__